<template>
	<div class="branch-container">
		<div class="page_title">
			<div class="titele-box">
				<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>我的资料</el-breadcrumb-item>
					<el-breadcrumb-item>个人信息</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="title">个人信息</div>
			</div>
		</div>
		<div class="user_info">
			<div class="info_box">
				<div class="content_box">
					<el-form
						ref="user_form"
						:model="user_form"
						label-width="100px"
						:rules="rules"
						:hide-required-asterisk="true"
					>
						<!-- 头像 -->
						<el-form-item label="头像：" v-if="showChenge('头像')">
							<div class="img_box">
								<div class="img">
									<!-- <img :src="user_form.user_head_img" alt=""> -->
									<el-image style="width: 100px; height: 100px" :src="user_head_img" fit="cover">
									</el-image>
								</div>
								<div class="file">
									<el-upload
										class="upload-demo"
										:multiple="false"
										:limit="1"
										:on-exceed="handleExceed"
										:file-list="fileList"
										action=""
										:auto-upload="false"
										:on-change="handleChange"
									>
										<el-button class="upload_btn" size="small">
											<div><i class="el-icon-upload2"></i> 更换头像</div>
										</el-button>
									</el-upload>
								</div>
							</div>
						</el-form-item>

						<!--  -->
						<el-form-item label="账号：" v-if="showChenge('OA账号')">
							<el-input v-model="user_form.user_name" disabled></el-input>
						</el-form-item>
						<el-form-item label="公司名称：" prop="user_company" v-if="showChenge('公司名称')">
							<el-input
								v-model="user_form.user_company"
								placeholder="请输入公司名称"
								maxlength="35"
							></el-input>
						</el-form-item>
						<el-form-item label="姓名：" prop="real_name" v-if="showChenge('姓名')">
							<el-input
								v-model="user_form.real_name"
								placeholder="请输入姓名"
								maxlength="25"
								minlength="2"
							></el-input>
						</el-form-item>
						<el-form-item label="联系电话：" prop="user_phone" v-if="showChenge('联系电话')">
							<el-input
								v-model="user_form.user_phone"
								placeholder="请输入联系电话"
								maxlength="20"
							></el-input>
						</el-form-item>
						<el-form-item label="邮箱：" prop="user_Email" v-if="showChenge('邮箱')">
							<el-input
								v-model="user_form.user_Email"
								placeholder="请输入邮箱"
								maxlength="50"
							></el-input>
						</el-form-item>
						<el-form-item label="部门：" prop="user_user_trump" v-if="showChenge('部门')">
							<!-- <el-input v-model="user_form.user_department" disabled></el-input> -->
							<el-input v-model="user_form.user_bu_meng" disabled></el-input>
						</el-form-item>
						<el-form-item label="职务：" prop="position" v-if="showChenge('职务')">
							<el-input v-model="user_form.position" disabled></el-input>
						</el-form-item>
						<el-form-item label="所在区域：" prop="area" v-if="showChenge('所在区域')">
							<el-input v-model="user_form.area" disabled></el-input>
						</el-form-item>

						<el-form-item style="margin-top: 48px">
							<el-button
								class="subbmit_btn"
								type="primary"
								@click="onSubmit"
								:loading="!submitState"
								>提交</el-button
							>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * $userDetail 获取个人信息
	 * $userProfile 修改个人信息
	 * $uploadFormData 文件上传
	 */
	let timer = null;
	import { $userDetail, $userProfile, $uploadFormData } from '@/api/index';
	export default {
		data() {
			// let phoneRule = (rule, value, callback) => {
			//   // let regex = /^1[3456789]\d{9}$/
			//   let regex = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
			//   if (regex.test(value)) {
			//     return callback();
			//   } else {
			//     return callback("手机号错误");
			//   }
			// };
			return {
				fileList: [], // 上传列表
				user_head_img: '', // 用户头像
				user_form: {
					id: '',
					user_name: '',
					min_url: '',
					user_head_img: '',
					user_company: '',
					real_name: '',
					user_phone: '',
					user_Email: '',
					user_trump: '',
					user_department: '',
					position: '',
					area: '',
				},
				rules: {
					user_company: [{ required: true, message: '请输入公司名', trigger: 'blur' }],
					real_name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' },
						{ min: 2, max: 20, message: '请输入2~20个字符', trigger: ['blur', 'change'] },
					],
					user_phone: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' },
						// {
						//   validator: phoneRule,
						//   message: "请输入正确的联系电话",
						//   trigger: ["blur", "change"],
						// },
					],
					user_Email: [
						{ required: true, message: '请输入邮箱', trigger: 'blur' },
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: ['blur', 'change'],
						},
					],
				},

				// 权限
				permissions: {},
				tabsList: [],
				tabsList2: [],

				submitState: true, // 提交状态
				throttleState: false,
			};
		},
		created() {
			// this.user_form = {
			//   id: "123456",
			//   user_head_img: "http://cdn-design.oss-accelerate.aliyuncs.com/design/upload/2022-06-10/6978fc1a0475a86a474e615e3.jpeg?OSSAccessKeyId=LTAI4FuCdXnVWfnKJu3SFHRo&Expires=1655436148&Signature=mXavK8UCeqd%2FQ%2FVDhY4voLAAB7s%3D",
			//   company_name: '惠州一匠科技',
			//   real_name: "李嘉琪",
			//   user_phone: "13562100002",
			//   user_Email: "482000222@qq.com",
			//   user_department: "业务部", ///
			//   position: "业务员",
			//   area: "南区",
			// };

			this.getTagPermissions();
			this.userDetail();
		},
		mounted() {},
		methods: {
			// 获取权限
			getTagPermissions() {
				// 获取 用户展示内容权限
				this.$data.permissions = this.$store.state.personalCenterPermissions.find(function check(
					val
				) {
					return val.name === '我的资料';
				});
				// console.log(this.$data.permissions);
				// 标签页 标头
				this.tabsList = this.permissions.children[0].children;
				this.tabsList2 = this.tabsList.map((item) => {
					return item.name;
				});
				// console.log(this.tabsList2);
			},
			// 获取个人信息
			userDetail() {
				$userDetail()
					.then((res) => {
						// console.log("获取个人信息", res);
						this.user_form = res.data;
						this.user_form.min_url = res.data.min_url;
						this.user_head_img = res.data.user_head_img;

						// console.log(this.user_form, res.data.user_head_img);
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 修改个人信息
			userProfile(params) {
				$userProfile(params)
					.then((res) => {
						// if (res.code == 400) return this.$message.error(res.msg); // 失败提示
						this.$message({
							showClose: true,
							message: '修改成功！',
							type: 'success',
						}); // 成功提示
						let localInfo = this.$store.state.userInfo;
						$userDetail()
							.then((res) => {
								if (res) {
									this.$store.commit('SetUserInfo', {
										...localInfo,
										...res.data,
									});
									timer = setTimeout(() => {
										window.location.reload();
									}, 300);
								}
							})
							.catch((err) => {
								console.log(err);
							});
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 上传文件，获取文件流
			handleChange(file) {
				let param = new FormData();
				param.append('file', file.raw);
				$uploadFormData({ formData: param })
					.then((res) => {
						// console.log('上传成功', res)
						this.user_head_img = res.data.temporary_url;
						this.user_form.min_url = res.data.url;
					})
					.catch((err) => {
						console.log(err);
					});
				console.log('上传文件', this.fileList);
			},

			// 文件上传 限制
			handleExceed(files, fileList) {
				// 文件超出个数限制
				this.$message.warning(
					`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
						files.length + fileList.length
					} 个文件`
				);
			},

			// 表单提交
			onSubmit() {
				// 节流
				if (this.throttleState) return; // 节流
				this.throttleState = true;

				this.submitState = false;
				this.$refs['user_form'].validate((valid) => {
					if (valid) {
						let params = {
							name: this.user_form.real_name,
							phone: this.user_form.user_phone,
							email: this.user_form.user_Email,
							avatar: this.user_form.min_url,
						};

						this.showChenge('公司名称') ? (params.company = this.user_form.user_company) : '';

						console.log('上传参数', params);
						this.userProfile(params);
						this.fileList = [];
						setTimeout(() => {
							this.submitState = true;
						}, 500);
					} else {
						this.submitState = true;
						console.log('error submit!!');
						return false;
					}
				});

				setTimeout(() => {
					this.throttleState = false;
				}, 2000);
			},

			// showChenge
			showChenge(str) {
				let showState = false;
				this.tabsList2.filter((item) => {
					if (item == str) return (showState = true);
				});
				// console.log(showState);
				return showState;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.titele-box {
		background-color: #fff;
		padding: 20px 30px;
		.title {
			font-size: 20px;

			font-weight: bold;
			margin-top: 22px;
			color: rgba(0, 0, 0, 0.85);
			opacity: 1;
		}
	}
	.user_info {
		width: 100%;
		height: calc(100% - 110px);
		padding: 24px;
		box-sizing: border-box;
		background: #f0f2f5;
		.info_box {
			width: 100%;
			height: 100%;
			background: #ffffff;
			position: relative;
		}
	}

	.content_box {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 600px;
		height: 100%;
		// border: 1px solid #ccc;
		padding-top: 48px;
	}
	.img_box {
		.img {
			width: 100px;
			height: 100px;
			line-height: 100px;
			border-radius: 50%;
			background: #ccc;
			margin-bottom: 16px;
			overflow: hidden;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.file {
			width: 100%;
			margin-bottom: 24px;
			.upload_btn {
				width: 100px;
				height: 32px;
				color: #333333;
				// font-size: 14px;
				padding: 0;
				i {
					font-weight: 700;
				}
			}
		}
	}

	.el-form-item {
		margin-bottom: 16px;
	}

	::v-deep {
		.subbmit_btn {
			background: #e60000;
			border: 0;
			&:hover {
				background: #e72535;
			}
		}
		.el-input.is-disabled .el-input__inner {
			color: #333333;
			background: #f5f5f5;
		}
		.el-breadcrumb__inner.is-link:hover {
			color: #e72535;
		}
	}

	.el-input {
		width: 400px;
	}

	// 必填框 提示符
	::v-deep {
		.el-form-item__label::before {
			content: '' !important;
			margin-right: 0px;
		}

		.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
			content: '*';
			color: #f56c6c;
			margin-left: 6px;
		}
	}
</style>
